<template>
    <div>
        <portlet
                :icon="'fi flaticon-pencil'"
                :title="'Product toevoegen'"
                :footer="true"
                :actionsBlock="true"
        >
            <div slot="actionsBlock">
                <router-link tag="button" :to="{name:'products'}" class="btn btn-primary">Ga Terug</router-link>
            </div>
            <div slot="portletBody">
                <div class="row">
                    <div class="form-group col-6">
                        <label class="form-label">Product naam</label>
                        <input type="text" class="form-control input-product-name" v-model="productName">
                    </div>
                    <div class="form-group col-6">
                        <label class="form-label">Yield %</label>
                        <input type="number" class="form-control input-product-norm" v-model="productNorm" min="1"
                               max="100">

                    </div>
                </div>
                <hr>
                <h4>Attributen</h4>
                <div v-for="(attribute, index) in getAttributes" :key="index" class="form-group row">
                    <label class="form-label col-md-2">{{attribute.name}}</label>
                    <div class="col-md-10">
                        <input type="text" class="form-control productAttributes" :data-attributeid="attribute.id">
                    </div>
                </div>
            </div>
            <div slot="portletFooter" class="col-12 text-right">

                <button @click="saveProduct" :disabled="!productName.length" type="submit" class="btn btn-primary">
                    Opslaan
                </button>

            </div>
        </portlet>
    </div>
</template>

<style scoped lang="scss">
    .form-group {
        margin-bottom: 1rem;

        label {
            margin-bottom: 0;
            line-height: 45px;
        }
    }
    hr {
        margin-top: 2rem;
        margin-bottom: 2rem;
        border-top: 1px solid rgba(255, 255, 255, 0.2)
    }
</style>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        props: ['id'],
        data() {
            return {
                productName: '',
                productNorm: ''

            }
        },
        computed: {
            ...mapGetters('products', [
                'getAttributes',
            ]),
        },
        methods: {
            ...mapActions('products', [
                'createProduct'
            ]),
            saveProduct() {

                if (this.productNorm > 100) {
                    this.$toasted.global.failedRequest({
                        message: 'Defecten norm moet tussen 0 en 100% zijn'
                    });
                } else {
                    let attributeArray = new Array();
                    $('.productAttributes').each(function () {
                        if ($(this).val() !== '') {
                            attributeArray.push({
                                attributeFieldDefinitionId: $(this).data("attributeid"),
                                value: $(this).val()
                            });
                        }
                    });

                    let productData = {
                        name: this.productName,
                        norm: parseInt(this.productNorm),
                        attributes: attributeArray
                    };

                    this.createProduct(productData).then(res => {
                        if (res) {
                            this.$router.push('/products')
                        }
                    })
                }
            }
        },
        watch: {
            'productNorm':
                function (newVal) {
                    if (newVal > 100) {
                        this.productNorm = 100;
                    }
                }
        }
        ,

    }
</script>